import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "suneditor/dist/css/suneditor.min.css";
import "quill/dist/quill.snow.css";

// module import
import { useSelector } from "react-redux";
import { Route, Routes, useLocation, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";

// utils
import { verifyToken } from "./Utils/authUtils";

// pages
import Dashboard from "./Page/Dashboard";
import ReporterPage from "./Page/ReporterPage";
import LoginAndRegistration from "./Page/LoginAndRegistration";
import Profile from "./Page/Profile";
import LocationPage from "./Page/LocationPage";
import CategoryPage from "./Page/CategoryPage";
import TopicPage from "./Page/TopicPage";
import HomePageSection from "./Page/HomePageSection";
import DepartmentPageSection from "./Page/DepartmentPageSection";
import NewsPage from "./Page/NewsPage";
import MenuPage from "./Page/ManuPage";
import VideoPage from "./Page/VideoPage";
import ImagesPages from "./Page/ImagesPage";
import WebAdsPage from "./Page/webAdsPage";
import GeneralSettingPagee from "./Page/generalSettingPage";
import FooterPage from "./Page/FooterPage";
import GalleryPage from "./Page/GalleryPage";
import PagePage from "./Page/PagePage";

// Components
import Footer from "./ChildComponents/Fotter";
import Header from "./Components/Admin/Header";
import AuthRedirectRoute from "./ConditionalComponents/AuthRedirectRoute";
import ProtectedRoute from "./ConditionalComponents/ProtectedRoute";
import RolePage from "./Page/RolePage";

function App() {
  const location = useLocation();
  const { token } = useSelector((state) => state.user);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [navData, setNavData] = useState([]);

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setIsTokenValid(false);
        return;
      }

      const { valid, data } = await verifyToken(token?.token);
      setIsTokenValid(valid);
      if (valid) {
        setNavData(data);
      }
    };

    validateToken();
  }, [token, location.pathname]);

  return (
    <>
      {isTokenValid ? <Header data={navData} /> : null}
      <Routes>
        <Route
          path="/login"
          element={
            <AuthRedirectRoute>
              <LoginAndRegistration />
            </AuthRedirectRoute>
          }
        />
        <Route path="/" element={<ProtectedRoute redirectTo="/login" />}>
          <Route index element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/user/role" element={<RolePage data={navData} />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/user/reporter" element={<ReporterPage />} />
          <Route path="/user/" element={<ReporterPage />} />
          <Route path="/settings/country" element={<LocationPage />} />
          <Route path="/category/all-category" element={<CategoryPage />} />
          <Route path="/category/topic" element={<TopicPage />} />
          <Route path="/settings/Menu" element={<MenuPage />} />
          <Route path="/post/news" element={<NewsPage />} />
          <Route path="/settings/footer" element={<FooterPage />} />
          <Route path="/post/images" element={<ImagesPages />} />
          <Route path="/post/videos" element={<VideoPage />} />
          <Route path="/ads/web" element={<WebAdsPage />} />
          <Route path="/ads" element={<WebAdsPage />} />
          <Route path="/user/department" element={<DepartmentPageSection />} />
          <Route path="/settings/section" element={<HomePageSection />} />
          <Route path="/admin" element={<Dashboard />} />
          <Route path="/settings/general" element={<GeneralSettingPagee />} />
          <Route path="/gallery/gallerys" element={<GalleryPage />} />
          <Route path="/post/page" element={<PagePage />} />
          {/* navigate route */}
          <Route path="/post" element={<Navigate to="/post/news" replace />} />
          <Route
            path="/category"
            element={<Navigate to="/category/all-category" replace />}
          />
          <Route
            path="/category"
            element={<Navigate to="/category/all-category" replace />}
          />
          <Route
            path="/gallery"
            element={<Navigate to="/gallery/gallerys" replace />}
          />
          <Route
            path="/ads"
            element={<Navigate to="/ads/customer" replace />}
          />
          <Route
            path="/settings"
            element={<Navigate to="/settings/general" replace />}
          />
        </Route>
      </Routes>
      {isTokenValid ? <Footer /> : null}
      <ToastContainer />
    </>
  );
}

export default App;
